import { IAnalyticsPieChartResponse } from '../../store/actions/WebAnalytics/HitsAnalyticsActions';
import { API_ROUTE } from '../ApiRoute';
import ApiService from '../ApiService';
import ApiServiceBase from '../ApiServiceBase';
import { ServerType, ServiceType } from '../ServiceType.data';

const serviceType = ServiceType.ANALYTICS;

export class HitsAnalyticsService {
  private readonly service: ApiServiceBase = new ApiService(serviceType, ServerType.dcaBackend);

  public getUserVsReturningUsers():
    | Promise<IAnalyticsPieChartResponse[]>
    | IAnalyticsPieChartResponse[] {
    const route: string[] = [API_ROUTE.NEW_VS_RETURNING_USERS];
    return this.service.get({
      route: route,
    });
  }
  public getUsageLevelRoleData():
    | Promise<IAnalyticsPieChartResponse[]>
    | IAnalyticsPieChartResponse[] {
    const route: string[] = [API_ROUTE.GET_ROLE_BASED_USAGE];
    return this.service.get({
      route: route,
    });
  }
  public getCloudStatusData():
    | Promise<IAnalyticsPieChartResponse[]>
    | IAnalyticsPieChartResponse[] {
    const route: string[] = [API_ROUTE.CLOUD.STATUS];
    return this.service.get({
      route: route,
    });
  }
  public getActiveUsersData():
    | Promise<IAnalyticsPieChartResponse[]>
    | IAnalyticsPieChartResponse[] {
    const route: string[] = [API_ROUTE.ACTIVE_USERS];
    return this.service.get({
      route: route,
    });
  }
  public getUserVisitsData(): Promise<IAnalyticsPieChartResponse[]> | IAnalyticsPieChartResponse[] {
    const route: string[] = [API_ROUTE.VISITS];
    return this.service.get({
      route: route,
    });
  }
  public getPageViewsData(): Promise<IAnalyticsPieChartResponse[]> | IAnalyticsPieChartResponse[] {
    const route: string[] = [API_ROUTE.PAGE_VIEWS];
    return this.service.get({
      route: route,
    });
  }

  public getAvgTimeData(): Promise<IAnalyticsPieChartResponse[]> | IAnalyticsPieChartResponse[] {
    const route: string[] = [API_ROUTE.AVERAGE_SESSION_TIME];
    return this.service.get({
      route: route,
    });
  }
}

const hitsAnalyticsService = new HitsAnalyticsService();
export default hitsAnalyticsService;
